import {
  Directive,
  ElementRef,
  HostListener,
  AfterViewInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[ellipsisTooltip]',
  standalone: true,
})
export class EllipsisTooltipDirective implements AfterViewInit, OnDestroy {
  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.updateTooltipAttribute();
    this.bindScrollContainer();
  }

  ngOnDestroy(): void {
    this.scrollContainer?.removeEventListener('scroll', this.onScroll);
  }

  private scrollContainer: HTMLElement | null = null;
  private onScroll = (): void => this.hideFloatingTooltip();

  private bindScrollContainer(): void {
    this.scrollContainer = this.elementRef.nativeElement.closest('tbody');
    this.scrollContainer?.addEventListener('scroll', this.onScroll, {
      passive: true,
    });
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateTooltipAttribute();
  }

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const el = this.elementRef.nativeElement;
    const isTruncated = el.scrollWidth > el.clientWidth;
    if (isTruncated) {
      const text = el.textContent?.trim() ?? '';
      if (text) this.showFloatingTooltip(text, el);
    } else {
      this.hideFloatingTooltip();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.hideFloatingTooltip();
  }

  private updateTooltipAttribute(): void {
    const el = this.elementRef.nativeElement;
    // guard: ensure layout calculated
    const isTruncated = el.scrollWidth > el.clientWidth;
    if (!isTruncated) this.hideFloatingTooltip();
  }

  private tooltipEl: HTMLDivElement | null = null;

  private showFloatingTooltip(text: string, anchor: HTMLElement): void {
    if (!this.tooltipEl) {
      this.tooltipEl = document.createElement('div');
      this.tooltipEl.className = 'ellipsis-floating-tooltip';
      document.body.appendChild(this.tooltipEl);
    }
    this.tooltipEl.textContent = text;
    const rect = anchor.getBoundingClientRect();
    const top = rect.bottom; // 4px gap
    const left = rect.left + 100; // offset 100px from the left edge of the cell
    this.tooltipEl.style.top = `${top}px`;
    this.tooltipEl.style.left = `${left}px`;
    this.tooltipEl.style.display = 'block';
  }

  private hideFloatingTooltip(): void {
    if (this.tooltipEl) {
      this.tooltipEl.style.display = 'none';
    }
  }
}
